import React, {useEffect} from 'react'
import {Grid, Typography} from "@mui/material";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";
import {useTranslation} from "react-i18next";


const GlossaryLayout = () =>{
    const dispatch = useAppDispatch();
    const {t} = useTranslation()
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/detail/glossary",
            type:"pageView"
        }))
    });

    const data:any = t("glossary_table_rows", { returnObjects: true });

    return(
        <React.Fragment>
            <Typography variant="h4" style={{fontWeight: "bold"}}>
                {t('navigation.glossary')}
            </Typography>
            <Grid container sx={{padding: "20px"}}>
                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table aria-label="simple table">
                        {/* Table Header */}
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ border: '1px solid black' }} align="center">{t('glossary_table_headers.name' as any)}</TableCell>
                                <TableCell sx={{ border: '1px solid black' }} align="center">{t('glossary_table_headers.description' as any)}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row:any, index:number) => (
                                <TableRow key={index}>
                                    <TableCell sx={{ border: '1px solid black' }}  align="left" component="th" scope="row">
                                        {row.key}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black' }} align="left">{row.value}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>


        </React.Fragment>
    )
}
export default GlossaryLayout
